import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

import { Curso } from '../../models/curso/curso.model';

@Injectable()
export class CursoService 
{
    constructor(private http: HttpClient) { }

    traeCursos(idTipo: any)
    {
        return this.http.get(`${environment.urlBase}/cursos/tipos/${idTipo}`, 
               { headers: this.armaCabecera() }).toPromise();
    }

    editaCuposCursos(cursos: Curso[])
    {
        return this.http.put(`${environment.urlBase}/becas/tipos/cursos/`, 
               cursos, { headers: this.armaCabecera() }).toPromise();
    }
    
    armaCabecera()
    {
        return new HttpHeaders({            
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}